export {
  MAILBOX_CONFIG,
  TITAN_CONFIG,
  GLOBAL_DEFAULT_NAMESERVERS,
};

const MAILBOX_CONFIG = {
  types: [
    {
      description: "Receive mail only",
      label: "Mail Forward ($5/yr)",
      name: "Mail forward",
      price: 5.0,
      price_label: "$5/yr",
      type: "forward",
    },

    {
      description: "Send & receive, 10GB storage",
      label: "Small Mailbox ($30/yr)",
      name: "Small mailbox",
      price: 30.0,
      price_label: "$30/yr",
      type: "regular",
    },

    {
      description: "Send & receive, 1TB storage",
      label: "Big Mailbox ($40/yr)",
      name: "Big mailbox",
      price: 40.0,
      price_label: "$40/yr",
      type: "mailplus",
    },
  ],
};

const TITAN_CONFIG = {
  types: [
    {
      id: "pro",
      description: "Essential, secure email to kickstart your business",
      taglines: [
        "10 GB email storage",
        "Webmail, apps for iOS & Android with built-in Calendar and Contacts",
      ],
      features: [
        "10 GB Email storage",
        "10 Read Receipts",
        "1 Email Template",
        "1 Contact Group",
        "Grammar & Spell Check",
        "Two-Factor Authentication",
        "Blocklist",
        "Allowlist",
        "Undo Send",
      ],
      label: "Pro Mailbox ($30/yr)",
      name: "Pro Mailbox",
      price: 30.0,
      price_label: "$30/yr",
      type: "pro",
    },

    {
      id: "premium",
      description: "Smart email tools to grow and organize your business",
      taglines: [
        "50 GB email storage",
        "Built-in tracking and productivity tools like Read Receipts, Email templates, Priority Inbox and 10 more features",
      ],
      features: [
        "Everything in Pro +",
        "50 GB Email storage",
        "Unlimited Read Receipts",
        "Unlimited Email Templates",
        "Unlimited Contact Groups",
        "Priority Inbox",
        "Titan Drive (1 GB storage)",
        "100 AI labels",
        "Business Auto-reply",
        "Password protected email",
        "Titan MCP",
        "Email labels",
        "Auto-clean",
        "Send Later",
        "Follow-up Reminders",
        "Turbo Search",
        "Send as Alias",
        "Undo send",
        "Branding",
        "Team Chat",
        "Tasks",
      ],
      label: "Premium Mailbox ($45/yr)",
      name: "Premium Mailbox",
      price: 45.0,
      price_label: "$45/yr",
      tag: "Recommended",
      type: "premium",
    },

    {
      id: "ultra",
      description: "AI-powered email with marketing tools to supercharge your growth",
      taglines: [
        "100 GB email storage",
        "Smart Write with AI, Email tracking, Signature Designer, Email Campaigns, Appointment Booking and 20 more",
      ],
      features: [
        "Everything in Premium +",
        "100 GB Email storage",
        "Unlimited Read Receipts",
        "Unlimited Email Templates",
        "Unlimited Contact Groups",
        "Email Backup (50 GB storage)",
        "Titan Drive (50 GB storage)",
        "Unlimited AI labels",
        "Titan AI (compose, reply)",
        "AI Summary",
        "AI Inbox",
        "Secure File Transfer",
        "Signature Designer",
        "File and Link Tracking",
        "Email Designer",
        "Email Campaigns",
        "Titan Bookings",
        "Invoice Builder",
      ],
      label: "Ultra Mailbox ($80/yr)",
      name: "Ultra Mailbox",
      price: 80.0,
      price_label: "$80/yr",
      type: "ultra",
    },
  ],
}

const GLOBAL_DEFAULT_NAMESERVERS = ["ns1.hover.com", "ns2.hover.com"];
